<template>
  <div class="roleBind">
    <div class="menuCont">
      <tree ref="myTree"
            :treeData="menuList"
            :treeLoading="treeLoading"
            :treeToolBar="treeToolBar"
            :defaultProps="defaultProps"
            :departTotal="departTotal"
            :nodeKey="'id'"
            @handleAddTreeNode="handleAddTreeNode"
            @handleTreeNodeClick="handleTreeNodeClick"
            :btnName="btnName"
            treeSearchBar
            @searchChange="searchChange">
      </tree>
    </div>
    <div class="tableCont">
      <div class="searchCont"
           style="padding-left: 10px">
        <div class="searchContLeft">
          <el-form :model="searchForm"
                   ref="searchForm"
                   :inline="true" @keydown.enter.native.prevent>
            <el-form-item label="员工姓名"
                          size="mini">
              <el-input clearable
                        placeholder="请输入员工姓名"
                        maxlength="20"
                        size="mini"
                        v-model="searchForm.name"
                        @keyup.enter.native="user(1)">
              </el-input>
            </el-form-item>
            <el-form-item label="联系电话"
                          size="mini">
              <el-input clearable
                        placeholder="请输入联系电话"
                        maxlength="20"
                        size="mini"
                        v-model="searchForm.phone"
                        @keyup.enter.native="user(1)">
              </el-input>
            </el-form-item>
            <el-form-item label="状态"
                          size="mini">
              <el-select v-model="searchForm.status"
                         size="mini"
                         placeholder="请选择状态">
                <el-option v-for="item in statusList"
                           :key="item.status"
                           :label="item.name"
                           :value="item.status"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item size="mini">
              <el-button type="primary"
                         icon="el-icon-search"
                         size="mini"
                         @click="user(1)">
              </el-button>
            </el-form-item>
          </el-form>
          <menuAuthBtn :menuAuth="menuAuth"></menuAuthBtn>
        </div>
      </div>

      <div class="table"
           :style="{ height: searchHigh }">
        <el-table :data="tableData"
                  highlight-current-row
                  height="100%"
                  @selection-change="handleSelectionChange">
          <el-table-column type="selection"
                           align="center">
          </el-table-column>
          <el-table-column label="工号"
                           property="job_no"
                           align="left">
          </el-table-column>
          <el-table-column label="员工姓名"
                           property="name"
                           align="left">
            <template slot-scope="scope">
              <div class="nameCont">
                <div class="headImg"
                     v-if="scope.row.headSrc">
                  <img :src="scope.row.headSrc"
                       alt="" />
                </div>
                <div class="memberName">
                  {{ scope.row.name }}
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="联系电话"
                           property="phone"
                           align="left"></el-table-column>
          <el-table-column label="性别"
                           property="sex_cn"
                           align="left"
                           width="80"></el-table-column>

          <el-table-column label="入职日期"
                           property="entry_date"
                           align="left"></el-table-column>
          <el-table-column label="所属部门"
                           property="depart_name"
                           align="left"
                           width="200"></el-table-column>
          <!-- <el-table-column label="职位"
                           property="position"
                           align="center"></el-table-column> -->
          <el-table-column label="角色"
                           property="role_name"
                           align="left"></el-table-column>
          <el-table-column label="当前状态"
                           align="left">
            <template slot-scope="scope">
              <el-tag size="mini"
                      :type="
                                    scope.row.status == 1
                                        ? 'success':scope.row.status == 10
                                        ?'warning':'error'
                                ">
                {{ scope.row.status_cn }}
              </el-tag>
            </template>
          </el-table-column>
          <!-- <el-table-column label="操作"
                           align="center">
            <template slot-scope="scope">
              <el-button v-for="item in scope.row.authority"
                         :key="item.id"
                         type="text"
                         size="small"
                         class="color-blue"
                         @click="rowDo(scope.row, item.url)">{{ scope.row.name }}</el-button>
            </template>
          </el-table-column> -->
        </el-table>
      </div>
      <pagination :paginationData="paginationData"
                  @paginationChange="paginationChange"></pagination>
    </div>

    <el-dialog class="setRole"
               :visible.sync="setRoleVisible"
               :close-on-click-modal="false"
               @closed="closeSetRoleDialog"
               width="400px"
               title="设置角色"
               :modal-append-to-body="false"
               append-to-body>
      <el-form :inline="true" @keydown.enter.native.prevent>
        <el-form-item label="绑定角色">
          <el-select v-model="roleId"
                     clearable
                     placeholder="请选择角色类型"
                     size="small">
            <el-option v-for="item in typeList"
                       :key="item.id"
                       :label="item.name"
                       :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer"
            class="dialog-footer">
        <el-button type="primary"
                   @click="setRoleSave"
                   size="mini">保 存</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import pagination from "@/common/components/pagination";
import * as api from "@/http/api.js";
import * as erpApi from "@/http/erpApi.js";
import tree from "@/common/components/treeChange";
import menuAuthBtn from "@/common/components/menuAuthBtn";
export default {
    data() {
        return {
            menuList: [],
            defaultActive: 0,
            searchForm: {
                name: "",
                phone: "",
                status: "",
            },
            depart_list: [],
            tableData: [],
            statusList: [
                { status: 1, name: "在职" },
                { status: 10, name: "离职" },
            ],

            paginationData: {
                page: 1,
                "per-page": 20,
                total: "",
            },

            detailVisible: false,
            tableItem: "",
            typeList: [],
            selectionUserIdList: [],
            setRoleVisible: false,
            typeList: [],
            roleId: 4,

            treeLoading: false,
            treeToolBar: false,
            defaultProps: {
                children: "child",
                label: "name",
            },
            menuAuth: [],
        };
    },
    methods: {
        user(page) {
            page ? (this.paginationData.page = 1) : "";
            erpApi
                .user(
                    {
                        menu_id: this.menu_id,
                        depart_list: this.depart_list,
                        ...this.searchForm,
                        ...this.paginationData,
                    },
                    "get"
                )
                .then((res) => {
                    if (res) {
                        this.tableData = res.data;
                        this.paginationData.total = res.total;
                        this.menuAuth = res.ext.op_auth ? res.ext.op_auth : [];
                    }
                });
        },
        paginationChange(paginationData) {
            this.paginationData = paginationData;
            this.user();
        },
        /**
         * 菜单选择
         */
        handleTreeNodeClick(sth, node) {
            this.searchForm = {
                name: "",
                phone: "",
            };
            this.paginationData.page = 1;
            this.paginationData.perPage = 10;
            let arr = [];
            this.judgeParentId(arr, node);
            this.depart_list = arr.reverse();
            this.user();
        },
        // 获取所有树节点id的递归
        judgeParentId(arr, node) {
            if (node.parent && !Array.isArray(node.parent)) {
                arr.push(node.data.id);
                this.judgeParentId(arr, node.parent);
            }
        },
        rowDo(row, url) {
            if (url == "detail") {
                this.detail(row);
            }
        },
        detail(row) {
            this.tableItem = row;
            this.detailVisible = true;
        },

        setRole() {
            this.getRoleList();
            if (this.selectionUserIdList.length) {
                this.setRoleVisible = true;
            } else {
                this.$message.error("请选择员工后操作");
            }
        },
        handleSelectionChange(val) {
            this.selectionUserIdList = [];
            for (let i in val) {
                this.selectionUserIdList.push(val[i].id);
            }
        },
        closeSetRoleDialog() {
            this.roleId = 4;
        },
        setRoleSave() {
            erpApi
                .userSetRole(
                    {
                        userId: this.selectionUserIdList,
                        roleId: this.roleId,
                    },
                    "post"
                )
                .then((res) => {
                    if (res) {
                        if (res.code == 200) {
                            this.$message.success("设置成功");
                            this.user();
                        }
                        this.setRoleVisible = false;
                    }
                });
        },
        getRoleList() {
            erpApi.role({}, "get").then((res) => {
                if (res) {
                    this.typeList = res.data;
                }
            });
        },
        authFunc(funcName) {
            this[funcName]();
        },

        /**
         * 获取组织架构
         */
        architecture() {
            api.architecture({}, "get").then((res) => {
                if (res) {
                    this.menuList = res.data.depart;
                }
            });
        },
    },
    created() {
        this.architecture();
        this.user();
        this.$nextTick(() => {
            this.$refs.myTree.$refs.tree.setCurrentKey(0);
        });
    },
    destroyed() {
        document.removeEventListener("keydown", this.enterKeyUp);
    },
    computed: {
        menuAuth() {
            return this.$store.state.menu.menuAuth;
        },
        menu_id() {
            return this.$store.state.menu.menu_id
                ? this.$store.state.menu.menu_id
                : localStorage.getItem("menu_id");
        },
    },
    components: {
        pagination: pagination,
        tree: tree,
        menuAuthBtn: menuAuthBtn,
    },
};
</script>
<style lang="scss">
.roleBind {
    width: 100%;
    height: 100%;
    background: #fff;
    display: flex;
    .menuCont {
        width: 250px;
        box-sizing: border-box;
        height: calc(100% - 10px);
        border: 1px solid #eee;
        &:hover {
            box-shadow: 2px 2px 10px #eee;
        }
    }
    .tableCont {
        width: calc(100% - 250px - 12px);
        margin-left: 12px;
        height: 100%;
        .table {
            height: calc(100% - 40px - 40px);
            width: 100%;
            // .el-scrollbar__wrap {
            //     overflow-x: hidden;
            // }
            .nameCont {
                display: flex;
                // align-items: center;
                // justify-content: center;
                .headImg {
                    height: 16px;
                    width: 16px;
                    border-radius: 8px;
                    overflow: hidden;
                    margin-right: 8px;
                }
                .memberName {
                    line-height: 24px;
                }
            }
        }
    }
    .bulkImport {
        .bulkText {
            text-align: left;
        }
        .condition {
            width: 100%;
            li {
                text-align: left;
                line-height: 2;
            }
        }
    }
    .el-scrollbar__wrap {
        overflow-x: hidden;
    }
}
</style>
